module.exports = __webpack_public_path__ + "img/messages-icon.fb7e21b6.svg";